import { DECIMAL_COEFFICIENT_STABLE_COIN, DECIMAL_COEFFICIENT_UNSTABLE_COIN, DECIMAL_PRECISION_STABLE_COIN, DECIMAL_PRECISION_UNSTABLE_COIN, } from '../constants';
export const round = (amount, ceil = true, roundingCoefficient, roundingPrecision) => {
    const coefficient = 10 ** roundingPrecision;
    const n = +(amount * coefficient);
    return (ceil ? Math.ceil(n) : Math.floor(n)) / coefficient;
};
export const calculateRoundingValues = (isStable) => {
    let roundingPrecision = DECIMAL_PRECISION_STABLE_COIN;
    let roundingCoefficient = DECIMAL_COEFFICIENT_STABLE_COIN;
    if (!isStable) {
        roundingPrecision = DECIMAL_PRECISION_UNSTABLE_COIN;
        roundingCoefficient = DECIMAL_COEFFICIENT_UNSTABLE_COIN;
    }
    return { roundingPrecision, roundingCoefficient };
};
//# sourceMappingURL=common.js.map